export const SITE_TITLE = "MK Tesisat & Tadilat | İstanbul";
export const SITE_DESC = "İstanbul'da tesisat, anahtar teslim tadilat, mutfak-banyo, salon-yatak odası, kırım-döküm ve moloz taşıma.";
export const PHONE_DISPLAY = "0539 257 14 53";
export const PHONE_TEL = "tel:+905392571453";
export const WHATSAPP_URL = "https://wa.me/905392571453?text=Merhaba%2C%20MK%20Tesisat%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum.";

export const services = [
  {
    slug: "tesisat-altyapi",
    number: "01",
    title: "Tesisat & Altyapı",
    short: "Su kaçağı, sıhhi tesisat, ısıtma ve altyapı çözümlerini temiz işçilikle tamamlıyoruz.",
    icon: "⌁",
    image: "https://images.pexels.com/photos/6419128/pexels-photo-6419128.jpeg?auto=compress&cs=tinysrgb&w=1200",
    text: "Kaçak tespitinden komple tesisat yenilemeye kadar tüm su, gider ve ısıtma işlerini planlı şekilde yapıyoruz.",
    bullets: ["Su kaçağı tespiti ve onarımı", "Sıhhi tesisat yenileme", "Kalorifer ve ısıtma hatları", "Gider açma ve yönlendirme", "Acil tesisat müdahalesi"],
    metaTitle: "İstanbul Tesisat & Altyapı | MK Tesisat",
    metaDesc: "İstanbul'da su kaçağı, sıhhi tesisat, ısıtma ve gider altyapısı için hızlı keşif ve temiz işçilik.",
  },
  {
    slug: "anahtar-teslim-daire",
    number: "02",
    title: "Anahtar Teslim Daire",
    short: "Dairenizi planlamadan son temizliğe kadar tek ekip, tek sorumlulukla yeniliyoruz.",
    icon: "↗",
    image: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=1400&q=85",
    text: "Keşif, plan, malzeme seçimi, uygulama ve teslim sürecini tek merkezden yönetiyoruz.",
    bullets: ["Ücretsiz keşif ve net iş programı", "Elektrik, su ve ısıtma koordinasyonu", "Zemin, boya ve duvar uygulamaları", "Mutfak-banyo entegrasyonu", "Son temizlik ve teslim"],
    metaTitle: "İstanbul Anahtar Teslim Daire Tadilatı | MK Tesisat",
    metaDesc: "Dairenizi keşiften son temizliğe tek ekiple yeniliyoruz; planlı, şeffaf ve zamanında teslim.",
  },
  {
    slug: "mutfak-banyo",
    number: "03",
    title: "Mutfak & Banyo",
    short: "Fonksiyonel mutfak dolapları, lavabo, banyo ve tuvalet tadilatını hayata geçiriyoruz.",
    icon: "▦",
    image: "https://images.unsplash.com/photo-1663811396733-4dc430f0115d?auto=format&fit=crop&w=1000&q=85",
    text: "Kullanım alışkanlığınıza göre ölçülendirilmiş, dayanıklı ve modern mutfak-banyo çözümleri kuruyoruz.",
    bullets: ["Mutfak dolabı ve tezgah yenileme", "Lavabo, batarya ve vitrifiye montajı", "Duşakabin ve seramik uygulama", "Su-gider hattı uyarlama", "Aydınlatma ve detay tamamlama"],
    metaTitle: "İstanbul Mutfak & Banyo Tadilatı | MK Tesisat",
    metaDesc: "Mutfak dolabı, lavabo, banyo ve tuvalet yenileme; ölçüye göre planlanan modern uygulama.",
  },
  {
    slug: "salon-yatak-odasi",
    number: "04",
    title: "Salon & Yatak Odası",
    short: "Salon, yatak odası ve yaşam alanlarını ferah, kullanışlı ve modern hale getiriyoruz.",
    icon: "◧",
    image: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=1400&q=85",
    text: "Boya, zemin, niş, aydınlatma ve ince tadilat işlerini evin geneline uyumlu şekilde tamamlıyoruz.",
    bullets: ["Boya ve duvar yenileme", "Laminat, parke ve zemin işleri", "Niş, kartonpiyer ve detaylar", "Aydınlatma ve priz düzenleme", "Küçük dokunuşlarla büyük değişim"],
    metaTitle: "İstanbul Salon & Yatak Odası Yenileme | MK Tesisat",
    metaDesc: "Salon ve yatak odasında boya, zemin, aydınlatma ve ince tadilat işleri tek ekipte.",
  },
  {
    slug: "kirim-dokum",
    number: "05",
    title: "Kırım & Döküm",
    short: "Kırım, döküm ve söküm işlerini kontrollü, güvenli ve komşu rahatsızlığı azaltılarak yapıyoruz.",
    icon: "◒",
    image: "https://images.pexels.com/photos/28041688/pexels-photo-28041688.jpeg?auto=compress&cs=tinysrgb&w=1000",
    text: "Tadilat öncesi tüm söküm ve kırım işlerini iş güvenliği kurallarına uygun şekilde organize ediyoruz.",
    bullets: ["Duvar ve seramik kırımı", "Eski tesisat ve armatür sökümü", "Mutfak-banyo sökümü", "Alanın işe hazır hale getirilmesi", "Günlük temiz çalışma düzeni"],
    metaTitle: "İstanbul Kırım & Döküm | MK Tesisat",
    metaDesc: "Tadilat öncesi kırım, döküm ve söküm işlerinde güvenli, kontrollü ve temiz süreç.",
  },
  {
    slug: "moloz-tasima",
    number: "06",
    title: "Moloz Taşıma",
    short: "Moloz ve hafriyatı hızlıca yükleyip uygun alanlara taşıyoruz, site içi düzeni koruyoruz.",
    icon: "⛟",
    image: "https://images.pexels.com/photos/28041688/pexels-photo-28041688.jpeg?auto=compress&cs=tinysrgb&w=1000",
    text: "Kırım sonrası moloz, inşaat atığı ve hafriyatın taşınmasını planlı araç ve ekip ile üstleniyoruz.",
    bullets: ["Moloz yükleme ve taşıma", "Hafriyat çıkış organizasyonu", "Apartman/site içi koruma", "Aynı gün hızlı tahliye", "Teslim öncesi alan temizliği"],
    metaTitle: "İstanbul Moloz Taşıma | MK Tesisat",
    metaDesc: "Moloz, inşaat atığı ve hafriyatın hızlı tahliyesi; apartman ve site düzeni korunarak taşıma.",
  },
];

export const projects = [
  { title: "Modern Mutfak", tag: "Mutfak yenileme", before: null, after: "https://images.unsplash.com/photo-1663811396733-4dc430f0115d?auto=format&fit=crop&w=1000&q=85" },
  { title: "Banyo Dönüşümü", tag: "Banyo & tesisat", before: null, after: "https://images.unsplash.com/photo-1663811397133-2d1f5addd9d5?auto=format&fit=crop&w=1000&q=85" },
  { title: "Temiz Başlangıç", tag: "Kırım & moloz", before: null, after: "https://images.pexels.com/photos/28041688/pexels-photo-28041688.jpeg?auto=compress&cs=tinysrgb&w=1000" },
];

export const testimonials = [
  { name: "Örnek Geri Bildirim", place: "İstanbul", text: "Keşif sonrası net plan çıktı, iş gün içinde toparlandı ve alan temiz teslim edildi.", sample: true },
  { name: "Örnek Geri Bildirim", place: "İstanbul", text: "Tek muhatap olması süreci çok rahatlattı; tesisat ve tadilat aynı ekipte kaldı.", sample: true },
  { name: "Örnek Geri Bildirim", place: "İstanbul", text: "Kırım ve moloz çıkışı hızlıydı, sonrasında banyo yenileme plana uygun ilerledi.", sample: true },
];

export const regions = ["İstanbul"];
export const hero = {
  eyebrow: "MK Tesisat & Tadilat",
  titleTop: "Yaşam alanınıza",
  titleAccent: "ustalık",
  titleBottom: "katıyoruz.",
  lead: "Tesisattan anahtar teslim tadilata, her işi tek bir ekip ve kusursuz bir planla tamamlıyoruz.",
  image: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=1400&q=85",
};

export const defaultContent = { hero, services, projects, testimonials, regions };

